









import { Component, Vue, Watch, Prop } from "vue-property-decorator";

@Component
export default class Loader extends Vue {
  @Prop() public Text?: string | boolean;
}
